import { Container, Row, Col, Dropdown, Button } from "react-bootstrap";
import { Heading } from "@/ui/Heading";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Arrow from "@/assets/ArrowDown.svg";
import ExternalLink from "@/assets/ExternalLink.svg";
import Calendar from "@/assets/CalendarSolid.svg";
import Users from "@/assets/Users.svg";
import { landing_pages_helper } from "@/helpers/landing_pages_helper";

export const CaseStudiesSection = ({ className, title }) => {
  const page = landing_pages_helper.find("services");
  const items = page?.case_studies || [];

  return (
    <div className={clsx(className, classes.casestudies)}>
      <Container>
        <Heading>
          <h2>{title}</h2>
        </Heading>
        <Row className="position-relative">
          {items?.map((i, k) => {
            return (
              <Col key={k} xs={12} md={4}>
                <div className={clsx(classes.card, "mb-3 mb-md-4")}>
                  <Dropdown data-dropdown={`case-study-${k}`} className="h-100 mb-4 mb-md-0">
                    <Dropdown.Toggle className="h-100">
                      <span className="h3">{i.title}</span>
                      <Arrow width={50} height={50} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu flip={false} renderOnMount={true} className="p-4 p-md-5">
                      <Row>
                        <Col xs={{ size: 12, order: 1 }} md={{ size: 3, order: 0 }}>
                          {i.link && (
                            <Button
                              href={i.link}
                              variant="link"
                              className="flex-column gap-2 w-100 my-4 mb-md-0 text-decoration-none"
                            >
                              <ExternalLink width="80" />
                              <span className="h3 m-0 p-3">Read more</span>
                            </Button>
                          )}
                          {i.download && (
                            <Button
                              href={i.download}
                              variant="link"
                              className="flex-column gap-2 w-100 my-4 mb-md-0 text-decoration-none"
                              target="_blank"
                            >
                              <ExternalLink width="80" />
                              <span className="h3 m-0 p-3">Click to see our impact</span>
                            </Button>
                          )}
                        </Col>
                        <Col xs={12} md={9}>
                          <div className="pe-md-5">
                            {i.blurb && (
                              <aside
                                dangerouslySetInnerHTML={{ __html: i.blurb }}
                                className="lead border-start border-5 border-white ps-3 ps-md-4 mb-5"
                              />
                            )}
                            <Row className="gap-5 gap-md-0">
                              {i.duration && (
                                <Col xs={12} md={6}>
                                  <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
                                    <Calendar height="70" />
                                    <span className="h5 m-0">{i.duration}</span>
                                  </div>
                                </Col>
                              )}
                              {i.team && (
                                <Col xs={12} md={6}>
                                  <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
                                    <Users height="70" />
                                    <span className="h5 m-0">{i.team}</span>
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default CaseStudiesSection;
